export default {
	"Rush.ItsLateOhTheEventIsOver": "It's late, oh, the event is over",
	"Rush.HotRush": "Hot rush",
	"Rush.fromTheEnd": "from the end",
	"Rush.OnlyTheBeginningIsLeft": "Only the beginning is left",
	"Rush.sky": "sky",
	"Rush.time": "time",
	"Rush.divide": "divide",
	"Rush.second": "second",
	"Rush.MarketingMarketplaceListingPageProductClick": "Marketing Marketplace listing page_Product click",
	"Rush.AListOfStoreItems": "A list of store items",
	"Rush.MarketingMarketplace": "Marketing Marketplace",
	"Rush.SnapItUpNow": "Snap it up now",
	"Rush.RobbedOfTheLight": "Robbed of the light ~"
}